import DocumentFolder from "../../slices/documents/folder/Folder"
import DocumentFile from "../../slices/documents/file/File"

const documentsReducer = {
    documentFolder: DocumentFolder,
    documentFile: DocumentFile,
}

export default documentsReducer;